import * as yup from "yup";
import { BackgroundRemovalStrategy, BackgroundEraserFormValues } from "./types";

export const defaultFormValues: BackgroundEraserFormValues = {
  bgApiKey: "",
  aiApiKey: "",
  bgRemovalStrategy: BackgroundRemovalStrategy.RemovalBgStrategy,
  automaticBackgroundRemoval: false,
};

export const schema = yup.object().shape({
  bgApiKey: yup.string().when("bgRemovalStrategy", {
    is: BackgroundRemovalStrategy.RemovalBgStrategy,
    then: (schema) => schema.required("Background API Key is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  aiApiKey: yup.string().when("bgRemovalStrategy", {
    is: BackgroundRemovalStrategy.RemovalAiStrategy,
    then: (schema) => schema.required("AI API Key is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  bgRemovalStrategy: yup
    .string()
    .required("Background Removal Strategy is required"),
  automaticBackgroundRemoval: yup.boolean(),
});
